<template>
  <div class="flex justify-center items-center h-40">
    <img class="w-15 h-15" src="@/assets/loader.gif" />
  </div>
</template>

<script>
export default {};
</script>